/**
 * ===================================================
 * Module: frontend.src.utils.pdfConfig.ts
 * Description: Shared PDF.js configuration for Japanese text support
 * Owner: Kawada Technosystem Co Ltd
 * All Rights Reserved
 * ===================================================
 */

import * as pdfjsLib from 'pdfjs-dist';

// Configure PDF.js worker
pdfjsLib.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';

// Get the base URL for CMap files
const getBaseUrl = () => {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return '';
};

// PDF.js configuration for Japanese text support
export const PDF_CONFIG = {
  cMapUrl: `${getBaseUrl()}/cmaps/`,
  cMapPacked: true,
  useWorkerFetch: true,
  isEvalSupported: false,
  useSystemFonts: true,
};

// Configure global settings
(pdfjsLib as any).disableFontFace = false;
(pdfjsLib as any).disableRange = false;
(pdfjsLib as any).disableStream = false;

// Helper function to load PDF with proper configuration
export const loadPdfDocument = async (source: ArrayBuffer | Uint8Array | string | any) => {
  let config: any;
  
  if (source instanceof ArrayBuffer || source instanceof Uint8Array) {
    config = {
      data: source,
      ...PDF_CONFIG
    };
  } else if (typeof source === 'string') {
    config = {
      url: source,
      ...PDF_CONFIG
    };
  } else if (source && typeof source === 'object') {
    config = {
      ...source,
      ...PDF_CONFIG
    };
  } else {
    throw new Error('Invalid PDF source. Must be ArrayBuffer, Uint8Array, URL string, or configuration object.');
  }
  
  return await pdfjsLib.getDocument(config).promise;
};

export default pdfjsLib;
